import { emoji as actions } from '../actions'

export const reducer = {}

reducer[actions.MAKE_REQUEST] = ({ state }) => ({
  ...state,
  isFetching: true,
  didInvalidate: false
})

reducer[actions.INVALIDATE_DATA] = ({ state }) => ({
  ...state,
  didInvalidate: true
})

reducer[actions.RECEIVE_DATA] = ({
  state,
  action: {
    payload: { data, receivedAt }
  }
}) => ({
  ...state,
  isFetching: false,
  didInvalidate: false,
  data,
  receivedAt
})
